export default __webpack_public_path__ + "static/media/BillPay-Void2.fe6b5146.svg";